import { getToken } from "@/helpers/auth-helper"
import axios from "axios"
import { json } from "react-router-dom"

export const show = async ({ params }) => {
    const token = getToken()

    return axios.get(`${process.env.REACT_APP_API_URL}/profile`, { headers: { Authorization: `Bearer ${token}` } }).then((res) => res.data.data).catch((error) => {
        throw new json(error, error.response.status)
    })
}